import React from "react";
import { tokens } from "../../public/tokens.js";

/**
 * Returns the style object for a result badge
 * based on the assessment outcome.
 */
export const getResultStyle = (result) => {
    const baseStyle = {
        display: "flex",
        height: "22px",
        padding: "0 6px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "2px",
        borderRadius: "10px",
        fontSize: tokens.typography.fontSize["md-12px"],
        fontWeight: tokens.typography.fontWeights.semibold,
        borderWidth: "1px",
        borderStyle: "solid",
    };

    switch (result) {
        case "Pass":
            return {
                ...baseStyle,
                borderColor: tokens.colors.states.success["500"],
                background: tokens.colors.states.success["500"],
                color: tokens.colors.neutral.white,
            };

        case "Fail":
            return {
                ...baseStyle,
                borderColor: tokens.colors.states.alert["500"],
                background: tokens.colors.states.alert["500"],
                color: tokens.colors.neutral.white,
            };

        case "Pending":
            return {
                ...baseStyle,
                borderColor: "rgba(173, 181, 189, 0.2)",
                background: "rgba(173, 181, 189, 0.2)",
                color: tokens.colors.neutral.grey["800"],
            };

        case "Exempted":
            return {
                ...baseStyle,
                borderColor: tokens.colors.brand["veld-sprout"]["700"],
                background: tokens.colors.brand["veld-sprout"]["700"],
                color: tokens.colors.neutral.white,
            };

                 case "Withheld":
            return {
                ...baseStyle,
                borderColor: tokens.colors.brand["burnt-orange"]["600"],
                background: tokens.colors.brand["burnt-orange"]["600"],
                color: tokens.colors.neutral.white,
                 textTransform: "capitalize",
            };

             case "Condoned":
            return {
                ...baseStyle,
                borderColor: tokens.colors.brand["veld-sprout"]["700"],
                background: tokens.colors.brand["veld-sprout"]["700"],
                color: tokens.colors.neutral.white,
            };

        default:
            return baseStyle;
    }
};

/**
 * Returns the text style for a mark
 * based on the overall result.
 */
export const getMarkColor = (result) => {

    const baseStyle = {
        fontSize: tokens.typography.fontSize["base-16px"],
        fontWeight: tokens.typography.fontWeights.bold,
    };

    switch (result) {
        case "Pass":
            return {
                ...baseStyle,
                color: tokens.colors.brand["fresh-green"]["900"],
            };
        case "Fail":
            return {
                ...baseStyle,
                color: tokens.colors.brand.red["700"],
            };
        case "Withheld":
            return {
                ...baseStyle,
                color: tokens.colors.brand["burnt-orange"]["600"],
                textTransform: "uppercase",
            };
            case "Condoned":
            return {
                ...baseStyle,
                color: tokens.colors.brand["veld-sprout"]["700"],
            };
        default:
            return {
                ...baseStyle,
            }
    }
};

/**
 * Formats a result value into a
 * user-friendly display string.
 */
export const formatResult = (value) => {
  if (!value) return "-";

  switch (value.toLowerCase()) {
    case "pass":
      return "Pass";
    case "fail":
      return "Fail";
    case "pending":
      return "Pending";
    case "exempted":
      return "Exempted";
      case "withheld":
      return "Withheld";
      case "condoned":
      return "Condoned";
    default:
      return "-";
  }
};

